import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
export var generateResizeFrameRatePayloads = function generateResizeFrameRatePayloads(props) {
  return props.frameRateSamples.map(function (frameRateSample, index) {
    return {
      action: ACTION.RESIZED_PERF_SAMPLING,
      actionSubject: ACTION_SUBJECT.ELEMENT,
      eventType: EVENT_TYPE.OPERATIONAL,
      attributes: {
        nodeType: props.originalNode.type.name,
        frameRate: frameRateSample,
        nodeSize: props.originalNode.nodeSize,
        docSize: props.docSize,
        isInitialSample: index === 0
      }
    };
  });
};
export var generateResizedEventPayload = function generateResizedEventPayload(_ref) {
  var node = _ref.node,
    prevWidth = _ref.prevWidth,
    newWidth = _ref.newWidth;
  return {
    action: ACTION.RESIZED,
    actionSubject: ACTION_SUBJECT.ELEMENT,
    eventType: EVENT_TYPE.TRACK,
    attributes: {
      nodeType: node.type.name,
      prevWidth: prevWidth,
      newWidth: newWidth
    }
  };
};